import { Briefcase, Building, ChevronLeftIcon, Clock, Mail, MapPin, Phone, User } from "lucide-react";
import { ContainerCard, EmployeeDetails } from "../../components/ui/cards";
import { useLocation, useNavigate } from "react-router-dom";
import useApiMethods from "../../lib/useApiMethods";
import ToastMsg from "../../components/common/ToastMsg";
import { useEffect, useState } from "react";
import { SUBORDINATE_ATTENDANCE_SUMMARY_URL, SUBORDINATES_URL } from "../../constants/api";
import { Reactable } from "../../components/ui/reactable";
import dayjs from "dayjs";

const SubordinateViewDetails = () => {

    let navigate = useNavigate();
    let location = useLocation();
    let { employeeID, subordinateId } = location?.state || {};

    const { fetch } = useApiMethods()
    const [data, setData] = useState(null)
    const [loading, setLoading] = useState(false);
    const [attendanceSummary, setAttendanceSummary] = useState(null);
    const [fetchFilter, setfetchFilter] = useState()
    const [totalRecords, setTotalRecords] = useState(0)

    const getSubordinateDetailsById = async (id) => {
        try {
            setLoading(true);
            const response = await fetch(SUBORDINATES_URL, { subordinate_id: id });

            if (response.status === 'success') {
                let data = response.data[0];
                setData(data);
            }

        } catch (error) {
            setLoading(false);
            ToastMsg('error', error.message)
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        getSubordinateDetailsById(subordinateId);
    }, [])

    const dayWiseAttendanceColumns = [
        {
            accessor: "date",
            Header: "Date",
            filterable: true,
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "shift",
            Header: "Shift",
            filterable: true,
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "check_in",
            Header: "Check In",
            Cell: ({ value }) =>
                value && dayjs(value).isValid()
                    ? dayjs(value).format("hh:mm A")
                    : "-",
        },
        {
            accessor: "check_out",
            Header: "Check Out",
            Cell: ({ value }) =>
                value && dayjs(value).isValid()
                    ? dayjs(value).format("hh:mm A")
                    : "-",
        },
        {
            accessor: "overtime",
            Header: "Overtime",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "break_hrs",
            Header: "Break Hours",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "total_working_hours",
            Header: "Total Hours",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "location",
            Header: "Location",
            Cell: ({ value }) => value ?? "-",
        },
    ];

    console.log(data);

    // {
    //     profile: 
    //     'https://svn-hrms-dev.s3.amazonaws.com/profile/sasuke-and-six-paths-naruto?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=ASIAT7TG52UHN7SFQF7K%2F20251114%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20251114T072516Z&X-Amz-Expires=600&X-Amz-SignedHeaders=host&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEJP%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaCmFwLXNvdXRoLTEiRzBFAiEAy9qUeke07GRgTFuGma6C2imEaYUoNeSQoXUIAMEhvHgCIBx9lqz0u7nfnJT2M7MsG3lxRuA8Xy%2F4dIxt22nK%2BP5vKrcFCFwQARoMMjc0MDIwMDI5NzEwIgzZ2MRIqVsBpARxHYwqlAVID1gatxRyAfMS2pAnMq%2F1ShnKwiCFx1fX9wPETnUwgvv%2FTX4UAMFfC4hce8ZRofEcikInM4YuV0pRN39QijdMQBE1FzmN3AnU%2B3xb5pzKo55VwB2fE4ElQsm2UmQ3yXYUHrmYnn%2BPlZE19QU4andCOFTNhDpSE%2Fu0zLlCO97RQ3HwZXrG3BBxDm2u2sF2TSusHkyo8%2F49pcUUn%2BJO4Hj%2B3x4KJFPjVb5s91slSMh3QB9otqm%2BjbZikOXVVaOnTSfnWhaLCUa1oN6d4rD8Q0pqidKljcXvX9m%2BvO7MGaTb2zDP97g8j2nrFeZ0BxatNdrbkNwIepHfjsL462F7UtMGpbM96IU1ZkLveFqNkagOI%2FOJgvEwaioWvzBfoXSBHQSl9Oqk4b97FpOZY14KZWQslTZg3KbbF2cg8PvhVIuneMLlrPYtqkrzbSb%2F8RW8%2BoNF4edTymv63qJZbYROV4bJoi4%2FofCf4RRM5y4sYGy6C0wmByQsDxT71X4F%2BD4jdK7U71GuIeh0wXbFsUh6xyDg09HFmws2fVXc0pn8egTuzWYhpT7Yc%2Bq53ZxY5tm%2FnyFq3l6DIbUf2kx%2B1JVo3sVoO34p4suDRbTk96p%2BDtNCQxqVfmnF%2FDNug%2F4m3wPHlQw4RYe%2BtHk00rbgUGosRGNY1TZ2hxW17TmzGunU%2F5XrDfq0oGXk2ubscYp0g7fqlMS40N1BKahgr8cBzYymbGKRGSV0wNLktj57li7Aws%2FEt%2BZb8i17Vl2ACE3mlrTnVPfSS3R4vVFKNk194uO297gB%2BUCpmTSkcMD2lvSObmUJvKYSwel%2F8OtgQ1GzK1DbXWCu%2BHhGAsguGk4%2B%2FcGFzHULsO33gJgI07TO7l4zx8sqZjvj6zYwy77ayAY6sQEkJR5PXHcMGx%2By3Lmepo4yGCK8kUEg0qmLaYIV9qL9MSnqefBnebqjJKxrNkoYbTCcC7r5bkgXO%2BgoJHZGImaAldCtWnQ6G3O0uTLA0NJohefjSFcAA%2FqwT0L2JK5v9YdjXmgbeuAATODLcoCKKjiJKx79T7mzx4lUPjufAMA8705pxN89Qys2wNl1YgRKachKc5Ickvc8KVsN%2FZoPziU1T2d7%2BcHsaJ9Gcfdx6YEG%2Bis%3D&X-Amz-Signature=5b86ba39861cd1b62267b87f1dd7ff05b90963f1a66bae49c1e3f26e143031f1',
    //     employee_name: 'Ram M',
    //     designation: 'Automation Tester',
    //     employee_id: 'Dhub253',
    //     department: 'Quality Assurance',
    //     email: 'ram@gmail.com',
    //     phone_number: '9880808090',
    //     location: 'Coimbatore',
    //     employee_type: 'Problematic employee',
    //     shift: 'Morning shift31',
    //     reporting_manager: 'HrBuddie Dev',
    //     work_location: null
    // }

    return (
        <ContainerCard>
            <div className="flex justify-between items-center mb-4">
                <span className=" flex gap-2 items-center">
                    <ChevronLeftIcon onClick={() => { navigate(-1) }} className=" cursor-pointer" />
                    <h1 className="text-xl font-semibold text-gray-900 dark:text-gray-100">
                        Subordinate Details
                    </h1>
                </span>
            </div>

            {loading ? (
                <div className="flex items-center justify-center h-32">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-sidebar-primary"></div>
                </div>
            ) : (
                <>
                    {data && (
                        <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 shadow-sm p-6 mb-6">
                            <div className="flex items-start gap-6 mb-3">
                                <div className="flex-shrink-0">
                                    <img
                                        src={data.profile || '/default-avatar.png'}
                                        alt="Profile"
                                        className="w-10 h-10 rounded-full object-cover border-2 border-gray-200 dark:border-gray-600"
                                    />
                                </div>
                                <div className="flex-1">
                                    <h2 className="text-xl font-bold text-gray-900 dark:text-gray-100">
                                        {data.employee_name}
                                    </h2>
                                    <div className=" flex gap-3 items-center">
                                        <p className="text-sm text-gray-600 dark:text-gray-400  border-r-2 pr-2">
                                            {data.designation}
                                        </p>
                                        <p className="text-sm text-gray-500 dark:text-gray-500">
                                            Employee ID: {data.employee_id}
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                                <div className="flex items-center gap-3 p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
                                    <Mail className="w-5 h-5 text-gray-500" />
                                    <div>
                                        <p className="text-sm text-gray-500 dark:text-gray-400">Email</p>
                                        <p className="text-sm font-medium text-gray-900 dark:text-gray-100">{data.email}</p>
                                    </div>
                                </div>

                                <div className="flex items-center gap-3 p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
                                    <Phone className="w-5 h-5 text-gray-500" />
                                    <div>
                                        <p className="text-sm text-gray-500 dark:text-gray-400">Phone</p>
                                        <p className="text-sm font-medium text-gray-900 dark:text-gray-100">{data.phone_number}</p>
                                    </div>
                                </div>

                                <div className="flex items-center gap-3 p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
                                    <MapPin className="w-5 h-5 text-gray-500" />
                                    <div>
                                        <p className="text-sm text-gray-500 dark:text-gray-400">Location</p>
                                        <p className="text-sm font-medium text-gray-900 dark:text-gray-100">{data.location}</p>
                                    </div>
                                </div>

                                <div className="flex items-center gap-3 p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
                                    <Building className="w-5 h-5 text-gray-500" />
                                    <div>
                                        <p className="text-sm text-gray-500 dark:text-gray-400">Department</p>
                                        <p className="text-sm font-medium text-gray-900 dark:text-gray-100">{data.department}</p>
                                    </div>
                                </div>

                                <div className="flex items-center gap-3 p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
                                    <Briefcase className="w-5 h-5 text-gray-500" />
                                    <div>
                                        <p className="text-sm text-gray-500 dark:text-gray-400">Employee Type</p>
                                        <p className="text-sm font-medium text-gray-900 dark:text-gray-100">{data.employee_type}</p>
                                    </div>
                                </div>

                                <div className="flex items-center gap-3 p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
                                    <Clock className="w-5 h-5 text-gray-500" />
                                    <div>
                                        <p className="text-sm text-gray-500 dark:text-gray-400">Shift</p>
                                        <p className="text-sm font-medium text-gray-900 dark:text-gray-100">{data.shift}</p>
                                    </div>
                                </div>

                                <div className="flex items-center gap-3 p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
                                    <User className="w-5 h-5 text-gray-500" />
                                    <div>
                                        <p className="text-sm text-gray-500 dark:text-gray-400">Reporting Manager</p>
                                        <p className="text-sm font-medium text-gray-900 dark:text-gray-100">{data.reporting_manager}</p>
                                    </div>
                                </div>

                                {data.work_location && (
                                    <div className="flex items-center gap-3 p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
                                        <MapPin className="w-5 h-5 text-gray-500" />
                                        <div>
                                            <p className="text-sm text-gray-500 dark:text-gray-400">Work Location</p>
                                            <p className="text-sm font-medium text-gray-900 dark:text-gray-100">{data.work_location}</p>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}

                    <div className="mb-4">
                        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100">Attendance Summary</h2>
                    </div>

                    <Reactable
                        columns={dayWiseAttendanceColumns}
                        data={attendanceSummary}
                        setData={setAttendanceSummary}
                        setTotalCount={setTotalRecords}
                        url={SUBORDINATE_ATTENDANCE_SUMMARY_URL}
                        serverSide={true}
                        tableHeight="calc(100vh - 400px)"
                        rowSize="md"
                        isCSVRequired={true}
                        isPDFRequired={true}
                        isMonthYearRequired={true}
                        filter={{ employee_id: employeeID }}
                        printFilter={{ employee_id: employeeID }}
                        manualPagination={true}
                    />
                </>
            )}
        </ContainerCard>
    );
}

export default SubordinateViewDetails;